import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { MessageCircle, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

// Simple context-free dialog that customers see after signup.
export function WelcomeWhatsAppDialog({ data, open, onClose }) {
    const [copied, setCopied] = useState(false);
    if (!data) return null;
    const copy = async () => {
        try { await navigator.clipboard.writeText(data.message || ''); setCopied(true); toast.success('Copied'); setTimeout(() => setCopied(false), 1500); } catch (e) { toast.error('Copy failed'); }
    };
    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent data-testid='welcome-whatsapp-dialog'>
                <DialogHeader>
                    <DialogTitle className='flex items-center gap-2'><MessageCircle className='w-5 h-5 text-[#25D366]' /> WhatsApp Onboarding</DialogTitle>
                </DialogHeader>
                <div className='space-y-3 text-sm'>
                    <div>Aapka account ready hai! Ek WhatsApp message hamari team ko bhejiye — hum 24 ghante mein contact karenge.</div>
                    <div className='rounded-lg border bg-muted/40 p-3 whitespace-pre-line text-xs max-h-40 overflow-y-auto'>{data.message}</div>
                    <div className='text-xs text-muted-foreground'>Business number: <b>+91 {data.business_number}</b></div>
                </div>
                <DialogFooter className='sm:justify-between'>
                    <Button variant='outline' onClick={copy} data-testid='whatsapp-copy-message'>{copied ? <Check className='w-4 h-4 mr-1' /> : <Copy className='w-4 h-4 mr-1' />} Copy Message</Button>
                    <a href={data.link} target='_blank' rel='noreferrer'>
                        <Button className='bg-[#25D366] hover:bg-[#1fbd58] text-white' data-testid='whatsapp-open-button'>
                            <MessageCircle className='w-4 h-4 mr-1' /> Open WhatsApp
                        </Button>
                    </a>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
export default WelcomeWhatsAppDialog;
